<template>
  <div>
    <common-dialog
      ref="dialog"
      show-save-button
      width="400px"
      unit="设备采集"
      edit-title
      id-key="DeviceLogId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.collect"
      :get-data-func="api.info"
      close-on-saved
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      :before-save="onBeforeSave"
      @details-opened="onDetailsOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="采集类型" prop="LogType">
              <el-radio-group v-model="data.LogType">
                <el-radio :label="0">日志</el-radio>
                <el-radio :label="1">数据库</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="采集日期" prop="LogDate">
              <el-date-picker v-model.trim="data.LogDate" type="date" value-format="yyyy-MM-dd" placeholder="选择时间"
                style="width:100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="采集设备" prop="CarId" class="is-required">
              <el-button type="primary" @click="openDeviceDialog">选择设备</el-button>
              <div class="car-box">
                <div class="item" v-for="(item,index) in ImeiMacs" :key="index">{{item}}
                  <i class="el-icon-delete" @click="delDevice(index)"></i>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <!-- <car-dialog ref="carDialog" in-dialog selectable @select-multiple="setCars" :show-record="false" multiple /> -->
    <device-dialog ref="deviceDialog" in-dialog selectable @select-multiple="setCars" multiple />
  </div>
</template>
<script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import api from "@/api/op/devicelog";
  import deviceDialog from "@/components/operate/device/listDialog";
  // import carDialog from "@/components/schoolmanage/car/listDialog";
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      deviceDialog,
      // carDialog,
    },
    data() {
      return {
        data: {
          LogDate: null,
          LogType: 0,
          DeviceIds: [],
        },
        DeviceNos:[],
        ImeiMacs:[],
        api,
        rules: {
          LogDate: [{ required: true, message: "请选择采集时间" }],
          LogType: [{ required: true, message: "请选择采集类型" }],
        },
      };
    },
    computed: {
    },
    methods: {
      onCreateOpened() {
      },
      onEditOpened(data) {
      },
      onDetailsOpened(row) {
        this.onEditOpened(row)
      },
      // openCarDialog() {
      //     this.$refs.carDialog.open().then((that) => {
      //         that.getData({ Status: 3 });// RecordStatus: 3
      //     });
      // },
      openDeviceDialog() {
          this.$refs.deviceDialog.open().then((that) => {
              that.getData({ });
          });
      },
      setCars(nos) {
        nos.forEach(e => {
          if(this.data.DeviceIds.indexOf(e.DeviceId) == -1) {
            this.DeviceNos.push(e.DeviceNo);
            this.ImeiMacs.push(e.ImeiMac);
            this.data.DeviceIds.push(e.DeviceId);
          }
        });
      },
      delDevice(index) {
        this.$confirm("确认删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.DeviceNos.splice(index,1);
            this.ImeiMacs.splice(index,1);
            this.data.DeviceIds.splice(index,1);
          })
          .catch(() => { });
      },
      onBeforeSave() {
        if(this.data.DeviceIds.length==0){
          this.$message.error("请选择要采集的设备");
          return false;
        }
      },
      onClosed() {
        this.data.DeviceIds = [];
        this.DeviceNos = [];
        this.ImeiMacs = [];
      },
    },
  };
</script>
<style lang="scss" scoped>
.car-box{
  border: 1px solid #ddd;
  border-radius: 4px;
  min-height: 200px;
  margin-top: 10px;
  .item {
    line-height: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    i {
      color: #409eff;
      cursor: pointer;
    }
  }
}
</style>